import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'

export default {
  GET_SMS_NOTIFICATION_HISTORY({ state, commit }, payload) {
    if (payload.offset === 0) {
      commit('setMessages', [])
    }

    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.smsHistory.all}`,
      {
        params: payload,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        commit('updateMessages', response.data.data.items)
        commit('sortMessagesByDate')
        commit('setSmsHistoryFilters', response.data.data.filters)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_SMS_NOTIFICATION_STATUSES({ state, commit }) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.smsHistory.statuses}`, {}, true).then(
      response => {
        if (response.data.result === 'success') {
          const result = _.map(response.data.data, (el, i) => ({ id: i, title: el, name: el }))
          commit('setSmsHistoryStatuses', result)
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },
  GET_NOTIFY_SMS_LOGS({ commit }, payload) {
    return request(
      'GET',
      `${Vue.config.notifyServer}/${Vue.config.modules.crm.api.smsHistory.receiverLogs}`,
      {
        params: payload,
      },
      true,
    )
  },
}
